import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import spinner from "../shared/loaders/img/spinner-white.gif";
import {
  StepButtons,
  PrevButton,
  NextButton,
  Loading,
} from "./styles/edit-form-styles";

class FormStepsButtons extends Component {
  state = {
    loadingPrev: false,
    loadingNext: false,
  };

  render() {
    const { loadingPrev, loadingNext } = this.state;
    const { step, handlePrev, handleNext, handleValidation, isPortalEmployer } =
      this.props;

    const runPrevHandlers = () => {
      this.setState({ loadingPrev: true });
      handleValidation().then((changePage) => {
        if (changePage) {
          handlePrev();
          this.setState({ loadingPrev: false });
        }
      });
    };

    const runNextHandlers = () => {
      this.setState({ loadingNext: true });
      handleValidation().then((changePage) => {
        if (changePage) {
          handleNext();
          this.setState({ loadingNext: false });
        }
      });
    };

    const displayNextButton = () => {
      const nextButtonElement = (
        <NextButton onClick={runNextHandlers} data-test-id="next-button">
          <FontAwesomeIcon icon={faArrowRight} />
          {loadingNext && <Loading src={spinner} alt="Spinner" />}
        </NextButton>
      );

      if (isPortalEmployer && step >= 10) return null;
      if (!isPortalEmployer && step >= 9) return null;
      return nextButtonElement;
    };

    return (
      <StepButtons>
        {step > 1 && (
          <PrevButton onClick={runPrevHandlers}>
            <FontAwesomeIcon icon={faArrowLeft} />
            {loadingPrev && <Loading src={spinner} alt="Spinner" />}
          </PrevButton>
        )}
        {displayNextButton()}
      </StepButtons>
    );
  }
}

FormStepsButtons.propTypes = {
  step: PropTypes.number.isRequired,
  handlePrev: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  handleValidation: PropTypes.func.isRequired,
  isPortalEmployer: PropTypes.bool.isRequired,
};

export default FormStepsButtons;
